const prefix = "app/ReportsV2/SummaryQuestions"

export const GET_LIST_COUNT_QUESTIONS_WATCHER = `${prefix}/GET_LIST_COUNT_QUESTIONS_WATCHER`
export const GET_LIST_COUNT_QUESTIONS_SUCCESS = `${prefix}/GET_LIST_COUNT_QUESTIONS_SUCCESS`
export const GET_LIST_COUNT_QUESTIONS_FAILED = `${prefix}/GET_LIST_COUNT_QUESTIONS_FAILED`
